import React from 'react'

function Checkbox({id, label, error, errorMessage, value, onChange, onFocus}) {
  return (
    <div className="columns is-gapless">
        <div className="column is-4">
        </div>
        <div className="column is-7">
            <p className={ error ? "control input is-danger" : "control" }>
              <label className="checkbox">
                <input data-id={ id } type="checkbox" onChange={ onChange } onFocus={onFocus} value={ value } checked={ value } />
                { label }
              </label>
            </p>
            {error ? <p className="help is-danger">{ errorMessage }</p> : null}
        </div>
      </div>
  )
}

export default Checkbox


// WEBPACK FOOTER //
// ./src/components/render/Checkbox.js